const deleteDialog = function (confirm, title, message, accept) {
  confirm.require({
    message: message,
    header: title,
    icon: 'pi pi-exclamation-triangle',
    rejectProps: {
      label: 'Cancel',
      outlined: true,
    },
    acceptProps: {
      label: 'Delete',
      severity: 'danger',
    },
    accept: accept,
    reject: () => {},
  })
}

const warnDialog = function (confirm, title, message, accept, dataTestId) {
  const acceptProps = {
    label: 'Proceed',
    severity: 'danger',
  }

  if (dataTestId) {
    acceptProps['data-test-id'] = dataTestId
  }

  confirm.require({
    message: message,
    header: title,
    icon: 'pi pi-exclamation-triangle',
    rejectProps: {
      label: 'Cancel',
      outlined: true,
    },
    acceptProps: acceptProps,
    accept: accept,
    reject: () => {},
  })
}

const toggleDialog = function (confirm, title, message, accept) {
  confirm.require({
    message: message,
    header: title,
    icon: 'pi pi-exclamation-triangle',
    rejectProps: {
      label: 'No',
      outlined: true,
    },
    acceptProps: {
      label: 'Yes',
      severity: 'success',
    },
    accept: accept,
    reject: () => {},
  })
}

export { deleteDialog, warnDialog, toggleDialog }
